// extracted by mini-css-extract-plugin
export var breadcrumb = "_2-0";
export var breadcrumbArrow = "_2-1";